import { getCachedData, setCachedData } from './cache';
import { catchError } from './catcher';
import { appendHeaders } from './headers';
import { getBaseApiUrl } from './stand';

export const baseFetch = async (url: string, options?: RequestInit & { customCache?: boolean }) => {
  const withOrigin = getBaseApiUrl() + url;
  const cacheKey = withOrigin;
  const cachedData = getCachedData(cacheKey);

  if (cachedData && options?.customCache) {
    return cachedData;
  }

  const controller = new AbortController();

  let response = await fetch(withOrigin, {
    ...options,
    headers: appendHeaders(options?.headers),
    signal: controller.signal,
  });

  if (!response.ok) {
    response = await catchError(response, withOrigin, options);
  }

  const data = await response.json();
  setCachedData(cacheKey, data);
  return data;
};
